import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { api } from '@/global/services/api'

const DEFAULT_EMPTY_VALUE = '--'
export default {
  methods: {
    showEdit (event) {
      const { id, description } = event?.data || {}
      this.$router.push({
        name: 'ReminderView',
        params: {
          id
        },
        query: {
          reminder: description || DEFAULT_EMPTY_VALUE
        }
      }).then()
    },

    onReminderActivation (event) {
      const { deactivated_at: deactivatedAt, id, description } = event?.data || {}
      if (!id) {
        return
      }
      const title = !deactivatedAt ? this.$t('satellite-tracking/reminders.deactivate') : this.$t('satellite-tracking/reminders.activate')
      this.$set(this.informationDialogConfig, 'title', title + (description ? ' - ' + description : ''))
      this.$set(this.informationDialogConfig, 'positiveBtnText', !deactivatedAt ? this.$t('base.deactivate') : this.$t('base.activate'))
      this.$set(this.informationDialogConfig, 'message', !deactivatedAt ? this.$t('satellite-tracking/reminders.confirm_deactivation') : this.$t('satellite-tracking/reminders.confirm_activation'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.reminderActivation(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async reminderActivation (event) {
      try {
        const { id, deactivated_at: deactivatedAt } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.reminders || {}
        await api('satellite-tracking').patch(`reminders/${id}/${deactivatedAt ? 'activate' : 'deactivate'}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    onReminderDelete (event) {
      const { id, name } = event?.data || {}
      if (!id) {
        return
      }

      const title = this.$t('satellite-tracking/reminders.delete')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (name || '/'))
      this.$set(this.informationDialogConfig, 'positiveBtnText', this.$t('base.save'))
      this.$set(this.informationDialogConfig, 'message', this.$t('satellite-tracking/reminders.confirm_removal'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.reminderDelete(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async reminderDelete (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.reminders || {}

        await api('satellite-tracking').delete(`reminders/${id}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
